import React from 'react';
import * as LucideIcons from 'lucide-react';

const InteractionUsersModal = ({ users, title, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-50" onClick={onClose}>
            <div className="bg-gray-900/80 p-6 rounded-lg shadow-glow max-w-md w-full border border-purple-500/50" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-2xl font-bold text-white font-playfair">{title}</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-white">
                        <LucideIcons.X size={24} />
                    </button>
                </div>
                <div className="space-y-4">
                    {users.map(user => (
                        <div key={user.id} className="flex items-center gap-4 p-2 rounded-lg bg-gray-800/50">
                            <img src={user.photoURL || `https://placehold.co/48x48/AEC6CF/FFFFFF?text=${user.displayName[0]}`} alt={user.displayName} className="w-12 h-12 rounded-full border-2 border-gray-700" />
                            <div>
                                <p className="font-bold text-white">{user.displayName}</p>
                                <p className="text-sm text-gray-400">@{user.username}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InteractionUsersModal;
